import { Employee } from '../utils/AccountsAPI';
import { createContext } from 'react';

export const UsersContext = createContext<[Employee[], Function, Function]>([[], () => {}, () => {}]);

export default UsersContext;
